(() => {
  const el = document.querySelector('[data-nlp]');
  if (!el) return;

  const delay = Number(el.dataset.delay || '2') * 1000;
  const oncePerDays = Number(el.dataset.oncePerDays || '7');
  const key = 'nlp_last_shown_at';

  const now = Date.now();
  const last = Number(localStorage.getItem(key) || '0');

  // oncePerDays = 0 => immer anzeigen
  if (oncePerDays > 0) {
    const ms = oncePerDays * 24 * 60 * 60 * 1000;
    if (last && now - last < ms) return;
  }

  const open = () => {
    el.classList.add('is-open');
    localStorage.setItem(key, String(Date.now()));
    document.addEventListener('keydown', onEsc);
  };

  const close = () => {
    el.classList.remove('is-open');
    document.removeEventListener('keydown', onEsc);
  };

  const onEsc = (e) => {
    if (e.key === 'Escape') close();
  };

  const closeBtn = el.querySelector('[data-nlp-close]');
  closeBtn?.addEventListener('click', close);

  // Klick auf Overlay schließt
  el.addEventListener('click', (e) => {
    if (e.target === el) close();
  });

  window.setTimeout(open, delay);
})();
